import React, { useEffect, useState } from 'react';
import { loansAPI } from '../services/api';
import './AgentPages.css';

const AllLoansPage = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLoans();
  }, []);

  const fetchLoans = async () => {
    try {
      setLoading(true);
      setError(null);
      const resp = await loansAPI.list({ page: 1, limit: 200 });
      let list = [];
      if (Array.isArray(resp)) list = resp;
      else if (resp && Array.isArray(resp.data)) list = resp.data;
      else if (resp && Array.isArray(resp.loans)) list = resp.loans;
      else list = resp?.data || resp || [];

      const normalized = (list || []).map((l) => {
        const amount = Number(l.requested_amount || l.amount || 0);
        const tenure = Number(l.tenure_days || l.tenureDays || l.tenure || 0) || 0;

        return {
          id: l.id,
          retailer: l.retailer_name || l.retailerName || (l.retailer && l.retailer.name) || '-',
          shop: l.shop_name || l.shopName || (l.retailer && l.retailer.shop_name) || '-',
          amount,
          tenure_days: tenure || '-',
          status: (l.status || '').toString(),
          created_at: l.created_at || l.createdAt || null,
        };
      });

      setLoans(normalized);
    } catch (err) {
      setError(err.message || 'Failed to load loans');
      setLoans([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>My Loans</h1>
        <p>All loans you have submitted</p>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loader" />
      ) : loans.length === 0 ? (
        <div className="no-data">No loans found</div>
      ) : (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                  <th>Loan ID</th>
                  <th>Retailer / Shop</th>
                  <th>Amount (₹)</th>
                  <th>Tenure (days)</th>
                  <th>Status</th>
                  <th>Created</th>
                </tr>
            </thead>
            <tbody>
              {loans.map((loan) => (
                <tr key={loan.id}>
                  <td style={{ fontFamily: 'monospace' }}>{String(loan.id || '').slice(0, 12)}</td>
                  <td>
                    <div style={{ fontWeight: 600 }}>{loan.retailer}</div>
                    <div style={{ color: '#666', fontSize: 12 }}>{loan.shop}</div>
                  </td>
                  <td>₹{loan.amount.toLocaleString()}</td>
                  <td>{loan.tenure_days}</td>
                  <td>
                    <span className={`badge badge-${(loan.status || '').toLowerCase()}`}>
                      {loan.status}
                    </span>
                  </td>
                  <td>{loan.created_at ? new Date(loan.created_at).toLocaleDateString() : 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AllLoansPage;
